import { useDashboardSummary } from './lib/useDashboardSummary';
import { useAnnualRevenue } from './lib/useAnnualRevenue';
import React, { useEffect, useState } from 'react';
import { LayoutDashboard, Maximize2 } from 'lucide-react';
import { BarChart, Bar, ResponsiveContainer } from 'recharts';
import FaturamentoTotal from './FaturamentoTotal';
import AnnualOperationalTotal from './components/dashboard/AnnualOperationalTotal';

const MiniChart = ({ color }) => {
  const data = Array.from({ length: 10 }, () => ({ val: Math.random() * 100 }));
  return (
    <div className="h-8 w-20 opacity-30">
      <ResponsiveContainer width="100%" height="100%">
        <BarChart data={data}>
          <Bar dataKey="val" fill={color} radius={[1, 1, 0, 0]} />
        </BarChart>
      </ResponsiveContainer>
    </div>
  );
};

function StatBox({ title, icon: Icon, color, border, dia, mes, ano, annualLoading, annualError, onExpand }) {
  return (
    <div className={`relative bg-[#161b22] border-l-4 ${border} px-5 py-5 min-h-[200px] rounded shadow-xl flex flex-col justify-between h-full transition-all hover:bg-[#1c222a]`}>
      {/* Botão de Expansão */}
      <button
        onClick={onExpand}
        className="absolute top-3 right-3 text-gray-600 hover:text-green-400 transition-colors z-20"
      >
        <Maximize2 size={18} />
      </button>

      <div className={`flex items-center gap-2 mb-2 ${color} font-black text-[10px] uppercase tracking-widest`}>
        <Icon size={14} /> <span>{title}</span>
      </div>

      <div className="flex justify-between items-end mb-2">
        <div>
          <p className="text-gray-500 text-[9px] font-bold uppercase mb-1 italic">Dia</p>
          <p className="text-white font-mono text-2xl font-bold italic tracking-tighter">
            R$ {Number(dia).toLocaleString('pt-BR', { minimumFractionDigits: 2 })}
          </p>
        </div>
        <MiniChart color="#4ade80" />
      </div>

      <div className="border-t border-gray-800 pt-2">
        <div className="flex justify-between items-center">
          <p className="text-gray-500 text-[9px] font-bold uppercase italic">Mês</p>
          <p className={`${color} font-mono text-lg font-bold italic tracking-tighter`}>
            R$ {Number(mes).toLocaleString('pt-BR', { minimumFractionDigits: 2 })}
          </p>
        </div>
      </div>    
      

      <AnnualOperationalTotal value={ano}

      loading={annualLoading} error={annualError} color={color} 
      />
    </div>
  );
}


export default function Faturamento({ onDataLoad, onRealizadoLoad, valorMeta, refreshSignal, onOpenDashboard, empresa = '' }) {


  const [isModalOpen, setIsModalOpen] = useState(false);

  const { data, loading, error } = useDashboardSummary('/api/dashboard/Faturamento', { empresa, refreshSignal });
  //const annual = useAnnualRevenue({ empresa, refreshSignal });
  useEffect(() => {
    onDataLoad?.(data?.valor_devolucoesMes ?? 0);
    onRealizadoLoad?.(data?.valor_Total ?? 0);
  }, [data, onDataLoad, onRealizadoLoad]);
  if (error) return <div role="alert" className="rounded border border-red-900 bg-[#161b22] p-4 text-xs text-red-300">{error}</div>;

  if (loading) {
    return (
      <div className="bg-[#161b22] border-l-4 border-green-500 px-5 py-5 rounded animate-pulse min-h-[200px]">
        <div className="h-4 bg-gray-800 rounded w-1/2 mb-4"></div>
        <div className="h-8 bg-gray-800 rounded w-3/4"></div>
      </div>
    );
  }

  return (
    <>
      <StatBox
        title="FATURAMENTO"
        icon={LayoutDashboard}
        color="text-green-400"
        border="border-green-500"
        dia={data?.valor_totalDia || data?.Valor_TotalDia || 0}
        mes={data?.valor_Total || data?.valor_Total || 0}
        ano={data?.totalFaturamentoAno || data?.totalFaturamentoAno || 0}
        //annualLoading={annual.loading}
       // annualError={annual.error}
        onExpand={() => setIsModalOpen(true)}
      />

      {isModalOpen && (
        <FaturamentoTotal
          data={data}
          onClose={() => setIsModalOpen(false)}
          onOpenDashboard={() => {
            setIsModalOpen(false);
            onOpenDashboard?.();
          }}
        />
      )}
    </>
  );
}
